<template>
  <div>
    <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
      <el-dialog :modal="true" :fullscreen="false" :title="'SMS Template'" :visible.sync="syncModal" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true" size="small" class="text-left item-dialog">
          <div>
              <div class="p-1">
                  <mdb-navbar class="z-depth-1 p-0 pl-2 rounded-sm justify-content-between m-1" style="background-color: #fff;">
                      <mdb-navbar-brand class="table-header-navbar-brand">
                          <mdb-tabs class="table-header-tabs" :active="activeTabIndex" default :links="mdbTabsData" @activeTab="getActiveTab"/>
                      </mdb-navbar-brand>
                  </mdb-navbar>
              </div>

              <div class="dialog-scroll-container">
                  <template v-if="activeTabSlot == 'main'">
                      <mdb-row class="tab-row">
                          <mdb-col lg="12" md="12" sm="12" class="mt-2 pl-0 pr-0">
                              <thats-fieldset class="m-2">
                                  <ThatsSeriesInput :show_error="true" tabindex="1" labelClass="col-md-2" fieldClass="col-md-10 pl-lg-0 pl-md-0" label="Name" placeholder="Name" vid="name" name="name" v-model="formData.name" :validated="validated" :rules="'required'" :keycode="false" size="sm" :readOnly="readOnly" />
                               <!--  <ThatsSeriesInput :show_error="true" tabindex="1" labelClass="col-md-2" fieldClass="col-md-10 pl-lg-0 pl-md-0" label="Mask" placeholder="Mask" vid="mask" name="mask" v-model="formData.mask" :validated="validated" :rules="'required'" :keycode="false" size="sm" :readOnly="readOnly" /> -->
                                <ThatsMultiSelect placeholder="Mask" :clearable="false" :multiple="false"  labelClass="col-md-2" fieldClass="col-md-10 pl-lg-0 pl-md-0"  label="MASK" v-model="formData.mask" :reduce="label => label.code" :reduceLabel="'label'" :options="smsMask" :rules="'required'" ></ThatsMultiSelect>  
                                <div ref="textareaWrapper">
                                  <ThatsTextarea :showLabel="true" :rows="5" tabindex="15" :labelClass="'col-md-2'" :fieldClass="'col-md-10 pl-lg-0 pl-md-0 item-textarea'" label="Description" placeholder="Description" vid="description" name="description" v-model="formData.content" size="sm" :readOnly="readOnly"/>
                                  </div>

                                  <div style="margin-left: 176px;">
                                      <mdb-badge  class="custom-badge z-depth-0 cursor-pointer" pill color="primary" size="sm" @click.native="insertAtCursor('{{customerName}}')">{{ customerName }}</mdb-badge>
                                      <mdb-badge  class="custom-badge z-depth-0 cursor-pointer" pill color="secondary" size="sm" @click.native="insertAtCursor('{{customerMobile}}')">{{customerMobile}}</mdb-badge>
                                      <mdb-badge  class="custom-badge z-depth-0 cursor-pointer" pill color="success" size="sm" @click.native="insertAtCursor('{{showroom}}')"> {{ showroom }}</mdb-badge>
                                      <mdb-badge  class="custom-badge z-depth-0 cursor-pointer" pill color="warning" size="sm" @click.native="insertAtCursor('{{salesPerson}}')">{{ salesPerson }}</mdb-badge>
                                  </div>



                                  <ThatsMultiSelect placeholder="Trigger" :clearable="false" :multiple="false"  labelClass="col-md-2" fieldClass="col-md-10 pl-lg-0 pl-md-0"  label="Trigger" v-model="formData.type" :reduce="label => label.code" :reduceLabel="'label'" :options="smsType" :rules="'required'" ></ThatsMultiSelect>

                                  <ThatsRadio tabindex="16" :labelClass="'col-md-2'" :fieldClass="'col-md-8  pl-0'" label="Status" vid="status" orientation="inline" name="status" :data="status" v-model="formData.status" :validated="validated" :rules="'required'" size="sm" :disabled="readOnly"/>
                              </thats-fieldset>

                              <thats-fieldset class="m-2">
                                  <ThatsSeriesInput :show_error="true" tabindex="1" labelClass="col-md-2" fieldClass="col-md-10 pl-lg-0 pl-md-0" label="TEST NUMBER" placeholder="TEST NUMBER" vid="name" name="name" v-model="formData.attr.test_destination" :validated="validated" :rules="''" :keycode="false" size="sm" :readOnly="readOnly" />
                              </thats-fieldset>
                          </mdb-col>

                      </mdb-row>

                  </template>



              </div>

          </div>
          <template slot="footer">
              <div class="pl-3 pr-3">
                  <div class="d-flex">

                    <template v-if="formLoading || viewLoading">
                        <mdb-btn color="elegant" size="sm" disabled>
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...
                        </mdb-btn>
                      </template>

                      <template v-else>

                        <template v-if="!readOnly">
                            <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)"><i class="el-icon-save text-white cursor-pointer"></i> Save</mdb-btn>

                            <template v-if="formStatus == 'update'"><mdb-btn color="elegant" size="sm" @click="passes(onSubmitTest)"><i class="el-icon-save text-white cursor-pointer"></i> SEND TEST</mdb-btn>
                            </template>
                        </template>
                        <mdb-btn color="grey" size="sm" @click="syncModal = false"><i class="el-icon-close text-white cursor-pointer"></i> Close</mdb-btn>

                      </template>


                  </div>
              </div>
          </template>
      </el-dialog>
      </ValidationObserver>

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { ValidationObserver } from "vee-validate";
import { mdbBtn,mdbBadge,mdbContainer,mdbSelect,mdbFormInline, mdbRow,mdbCol, mdbIcon, mdbCarousel, mdbCard, mdbCardImage,mdbTabs, mdbNavbar, mdbNavbarBrand} from "mdbvue";
import { ThatsMoney,ThatsMultiSelect,ThatsWindow,ThatsInput, ThatsSeriesInput,ThatsPriceInput,ThatsFieldset, ThatsRadio, ThatsCheckbox, ThatsAutocomplete,ThatsNumber, ThatsAutosuggest,ThatsTextarea, ThatsVueSelect} from '../../components/thats/Thats'


import { MessageBox, Message } from 'element-ui';

export default {
  components : {
      ThatsMultiSelect,
      mdbBadge,
      mdbBtn,
      mdbTabs,
      mdbNavbar,
      mdbNavbarBrand,
      mdbContainer,
      mdbSelect,
      mdbRow,
      mdbCol,
      mdbIcon,
      mdbCarousel,
      mdbCard,
      mdbCardImage,
      ValidationObserver,

       mdbFormInline,
      ThatsMoney,ThatsWindow,ThatsInput, ThatsSeriesInput,ThatsPriceInput,ThatsFieldset, ThatsRadio, ThatsCheckbox, ThatsAutocomplete,ThatsNumber, ThatsAutosuggest,ThatsTextarea, ThatsVueSelect
  },
  props : {
    group : {
          type : Number,
          default : 1
      },
      filterFormDataQuotation : {
          type: Object,
          default : () => ({
              searchTermQuot : null
          })
      },
  },
  inject : [],
  data(){
      return {
            customerName : `{{customerName}}`,
            customerMobile : `{{customerMobile}}`,
            showroom : `{{showroom}}`,
            salesPerson : `{{salesPerson}}`,
          syncModal : false,
          activeTabIndex : 0,
          activeTabObject : { text: 'Details', tabSlot : 'main' },
          mdbTabsData : [
              { text: 'Details', tabSlot : 'main' }
          ],
          group2 : 5,
          formData : null,
          formDataOrginal : null,
          formLoading : false,
          smsType : [
              { label : "New Customers, First Purchase", code : "sms-ncfp"},
              { label : "Returning Customer, New Invoice", code : "sms-invoice"},
              { label : "Welcome Message, New Visitors", code : "sms-welcome"},
              { label : "Reminder Message, New Visitors", code : "sms-reminder"},
              { label : "Welcome Message, New TL Rewards Member", code : "sms-rewards-welcome"},
          ],
          smsMask : [
              { label : "THATSLIVING", code : "THATSLIVING"},
              { label : "TL REWARDS", code : "TL REWARDS"},
          ],
          readOnly : true,
          showError : true,
          validated : true,


      }
  },
  created(){
      this.formData = JSON.parse(JSON.stringify(this.formObject))
      this.formDataOrginal = JSON.parse(JSON.stringify(this.formObject))
  },
  mounted(){
      const self = this


  },
  methods : {

      ...mapActions('SMSTemplateModule',['storeRecord','updateRecord','sendTestSMS']),

      openDialog(){
          this.syncModal = true
      },
      closeDialog(){
          this.syncModal = false
      },
      resetDefaultTab(){
          this.activeTabIndex = 0,
          this.activeTabObject = { text: 'Details', tabSlot : 'main' }
      },
      getActiveTab(v){
          this.activeTabIndex = v
          this.activeTabObject = this.mdbTabsData[v];
      },
      insertAtCursor(text) {
          this.$nextTick(() => {
              const textarea = this.$refs.textareaWrapper.querySelector('textarea');
              
              if (textarea) {
                  const startPos = textarea.selectionStart;
                  const endPos = textarea.selectionEnd;
                  const textBefore = this.formData.content.substring(0, startPos);
                  const textAfter = this.formData.content.substring(endPos, this.formData.content.length);
                  this.formData.content = textBefore + text + textAfter;
                  const newPos = startPos + text.length;
                  textarea.focus();
                  textarea.setSelectionRange(newPos, newPos);
              }
          });
      },
      onSubmitTest(){
            const self = this;
            MessageBox.confirm('Are you sure you want to send test message?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                Message.success({
                message: "SMS Test message was sent successfully!"
                });
                self.sendTestSMS({
                    mobile : self.formData.attr.test_destination,
                    type :self.formData.type,
                    action : 'test'
                }).then(() => {
                              self.$ThatsNotify.success(
                                {
                                    message : "Test message was sent"
                                }
                              )
                            })
            }).catch(() => {
                self.$ThatsNotify.error({
                    message : "Test message was not sent"
                })
            });

      },

    onSubmitForm(){
      var self =this
            this.validated = true
           this.$refs.observer.validate().then((isValid) => {

            // console.log(isValid)
            this.showError = false
            if (isValid) {
                // this.form.description = this.getText();
                    if(self.formLoading === false){
                      self.formLoading = true
                      if(self.formStatus == 'create'){


                          self.storeRecord(self.formData).then((response) => {
                              self.$ThatsNotify.success()
                              self.$emit('success',response)
                              self.closeDialog();
                              self.formLoading = false
                              /*
                              self.FormResetter(); */

                            }).catch((error) => {
                              self.formLoading = false
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }

                      if(self.formStatus == 'update'){
                          self.updateRecord(self.formData).then((response) => {
                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                                self.closeDialog();
                                self.$emit('success',response)
                                /* self.FormResetter(); */
                                self.formLoading = false

                            }).catch((error) => {
                              self.formLoading = false
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                    this.showError = true
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })


                      }
                    }

            }


            });


    },



  },

  computed : {
      ...mapGetters('SMSTemplateModule',{
          formRecord : 'formData',
          viewLoading : 'getLoading',
          postLoading : 'postLoading',
          formObject : 'initialFormObject',
          formStatus : 'formStatus',
      }),


      activeTabSlot : function(){
          return this.activeTabObject.tabSlot
      },

      status : function(){
          return [
              { label : 'Active', value : "active" },
              { label : 'Inactive', value : "inactive" }
          ]
      },


  },

  watch : {
      syncModal : function(value){
        const self = this;
          if(!value){
              this.cancelRequest();
              this.resetDefaultTab();
              this.formData = JSON.parse(JSON.stringify(this.formObject))
          }

          if(this.formStatus == 'update'){

        }
        this.readOnly = (this.$helpers.isSystemAdministrator() === true || this.$helpers.isBackOffice() || this.$helpers.itemCreate()) ? false : true;
      },

      formRecord : function(value){
          console.log("formRecord")
          console.log(value)

          const itemData = value;

          if(itemData.attr === null){
              itemData.attr = {
                    test_destination : null
              }
          }


          this.formData = {...itemData}
          this.formDataOrginal = JSON.parse(JSON.stringify({...itemData}))
      },

  }
}
</script>

<style scoped>
.click-to-add-logo{
font-size: 14px;cursor: pointer;
}



.custom-control {
  position: absolute!important;
  margin: 10px!important;
}

.custom-control.image-delete{
right: 0;cursor: pointer;
}

.custom-checkbox .custom-control-label::before {
  border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery{
padding: 158px 65px;
text-align: center;
}

.no-image-gallery i.far {
font-size: 42px;
color: #959595;
}

</style>
<style scoped>
.tab-col {
    position: relative;
}

.custom-pagination {
    position: absolute;
    bottom: 2px;
    width: 100%;
    text-align: center;
}
</style>


